import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import deTranslations from './locales/de.json';
import enTranslations from './locales/en.json';
import trTranslations from './locales/tr.json';
import ruTranslations from './locales/ru.json';
import arTranslations from './locales/ar.json';

const resources = {
  de: { translation: deTranslations },
  en: { translation: enTranslations },
  tr: { translation: trTranslations },
  ru: { translation: ruTranslations },
  ar: { translation: arTranslations },
};


i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'de',
    lng: localStorage.getItem('mosaik_language') || 'de',
    interpolation: {
      escapeValue: false,
    },
    detection: {
      order: ['localStorage', 'navigator'],
      lookupLocalStorage: 'mosaik_language',
      caches: ['localStorage'],
    },
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
  document.documentElement.dir = lng === 'ar' ? 'rtl' : 'ltr';
});

// Immediately fetch dynamic translations from backend and merge them in the background
const fetchDynamicTranslations = async () => {
  try {
    const apiBase = import.meta.env.VITE_API_URL || 'http://localhost:5048/api';
    const response = await fetch(`${apiBase}/public/translations?client=Mosaik`);
    if (response.ok) {
      const result = await response.json();
      if (result.succeeded && result.data) {
        const remoteResources = result.data;
        Object.keys(remoteResources).forEach((lang) => {
          i18n.addResourceBundle(lang, 'translation', remoteResources[lang], true, true);
        });
      }
    }
  } catch (error) {
    console.error('Failed to load dynamic translations:', error);
  }
};

fetchDynamicTranslations();

export default i18n;

